module.exports = __webpack_public_path__ + "static/media/gr5-newsletter-1.34af5488.pdf";